import { useState } from "react";

const TncRedeemNoteBox = ({ translation, productData }) => {
  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);

  return (
    <div className="tnc_redeem_note_box jlkkedit2 mt-lg-4 mb-4">
      <div
        className="item py-3"
        onClick={() => setOpenInst(!openInst)}
        style={{ cursor: "pointer" }}
      >
        <div className="text .jlkkedit2">{translation?.importantInstructions}</div>
        <div className="arrow">
          <i className={`fa-solid ${openInst ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openInst && (
        <div
          className="mt-2 mx-2 pd-left"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.instructionsContent || "",
          }}
        ></div>
      )}

      <div
        className="item py-3"
        onClick={() => setOpenRedeem(!openRedeem)}
        style={{ cursor: "pointer" }}
      >
        <div className="text">{translation?.how_to_use}</div>
        <div className="arrow " onClick={() => setOpenRedeem(!openRedeem)}>
          <i className={`fa-solid ${openRedeem ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openRedeem && (
        <div
          className="mt-2 mx-2 pd-left"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.howToUseContent || "",
          }}
        ></div>
      )}

      <div
        className="item py-3"
        onClick={() => setOpenTermsCon(!openTermsCon)}
        style={{ cursor: "pointer" }}
      >
        <div className="text">{translation?.terms_condition}</div>
        <div className="arrow" onClick={() => setOpenTermsCon(!openTermsCon)}>
          <i className={`fa-solid ${openTermsCon ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openTermsCon && (
        <div
          className="mt-2 mx-2 pd-left mb-2"
          style={{
            overflowWrap: "break-word",
          }}
          dangerouslySetInnerHTML={{
            __html: productData?.data?.tncContent || "",
          }}
        ></div>
      )}
    </div>
  );
};

export default TncRedeemNoteBox;
